import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { FILE_UPLOAD_POST } from "config/url";
import { useCurl } from "zh-common-modules";
import { DownloadUploadInput } from "../DownloadUploadInput";
function HookFormUpload(props) {
    const { value, onChange, label } = props;
    const [fileList, setFileList] = useState([]);
    const { curl } = useCurl();
    const handleUpload = (data, names) => {
        curl.post(FILE_UPLOAD_POST, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            timeout : 0
        }).then((res) => {
            setFileList([
                { value: res.id, label: names[0] }
            ]);
            onChange(res.id);
        });
    };
    // const handleDownload = (id) => {
    //     curl.download(FILE_DOWNLOAD_GET, { fileId: id }, { method: "GET" });
    // };
    useEffect(() => {
        if (typeof value === "object") {
            console.log(value);
            const realValue = value.map((file) => {
                return file.id;
            });
            onChange(realValue.join(','));
        }
    }, [onChange, value]);
    useEffect(() => {
        if (typeof value === "object") {
            const newFileList = value.map((file) => {
                return { value: file.id, label: file.name };
            });
            setFileList(newFileList);
        }
        // eslint-disable-next-line
    }, []);
    return (<>
      <DownloadUploadInput 
        label={label} 
        fileList={fileList} 
        handleUpload={handleUpload} 
        // handleDownload={handleDownload} 
        multiple={true}
      />
    </>);
}
export default function HookFormUploadWraper(props) {
    const { name, formContext, validate, value, ...rest } = props;
    return (<>
      <Controller as={<HookFormUpload />} validate={validate} name={name} defaultValue={value} {...formContext} {...rest}/>
    </>);
}
